export const TileIconDefProps = {
  tileIconType: 'finterms'
};